<template>
  <v-container>
    <v-row>
      <v-col  cols="12" lg="6" offset-lg="3">
        <ctx-manager v-if="!ctx"></ctx-manager>
        <recording-upload
          ref="rec"
          v-if="!recording"
        ></recording-upload>
        <div v-if="recording && ctx">
          <div class="overline ">
            <router-link class="primary--text" to="/home">home</router-link> >
            <router-link class="primary--text" to="/recordings">recordings</router-link> >
            {{ recording.title }}
          </div>
          <h1 class="title-logo primary--text">{{ recording.title }}</h1>
          <h2 class="grey--text"></h2>
          <!-- <v-overlay>
            <object type="text/html" :data="sessionLink(tune.session_id)" style="width:100%; height:100%">
              <p>backup content</p>
            </object>
          </v-overlay> -->
          <trad-player
            ref="player"
            :ctx="ctx"
            @end="$emit('end')"
            :inner-height="256"
            :onlysurf="true"
            :debug="false"
            :onlyread="true"
            :recording="recording"
            :setting="setting"
            ></trad-player>
          <TunePosition 
            v-for="tune in recording.tunes"
            :key="tune.id"
            :ref="'tunepos'+tune.id"
            :tune="tune"
            @fetch-start="getCursorPosition('start', 'tunepos'+tune.id)"
            @fetch-end="getCursorPosition('end', 'tunepos'+tune.id)"
          >
          </TunePosition>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CtxManager from '@/components/CtxManager'
import TradPlayer from '@/components/TradPlayer.vue';
import TunePosition from '@/components/TunePosition.vue';
import RecordingUpload from '@/components/RecordingUpload.vue';

  export default {
  name: 'TuneDetail',
  data: function () {
    return {
      playIndex: 0,
      tuneTitle: '',
      provideRec: null,
    }  
  },
  computed: {
    ctx() { return this.$store.state.tune.ctx},
    recordings() { return this.$store.state.tune.recordings},
    recording() {
      const id = this.$route.params.id
      return this.recordings.filter(function (x) {
        if (x.id == id)
          return x
      })[0];
    },
    setting() {
      return {
        player_settings: {},
        tune: null
      }
    }
  },
  components: {
    CtxManager,
    TradPlayer,
    RecordingUpload,
    TunePosition
  },
  mounted() {
    this.$store.dispatch('tune/getRecordingList');
  },
  methods: {
    // this.s
    sessionLink(id) { return "https://thesession.org/tunes/" + id },
    handleDialog(val) {
      alert(val)
    },
    getCursorPosition(bound, id) {
      // Access the child component instance
      const value = Math.floor(100 * this.$refs.player.getCurrentTime()) / 100;
      this.$refs[id][0]._data.position[bound] = value;
    }
  },
  filters: {
    capitalize(val) { 
     return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }
  }
}
</script>
<style lang="scss" scoped>
.session-text{
  color: #210000 !important;
}
.social-btn {
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
}
</style>